export const FETCH_ADMIN_DASHBOARD = 'fetchAdminDashboard';
export const FETCH_SITES = 'fetchSites';
